<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title>Manage bookmarks</v-card-title>
      <v-divider/>
      <v-card-text class="pb-0">
        <v-list ref="favourites" dense max-height="250px" class="overflow-y">
          <template v-for="favourite in myFavourites">
            <v-list-item :key="favourite.id" class="draggable">
              <v-list-item-icon>
                <v-icon class="handle">mdi-drag</v-icon>
                <!--
                <v-simple-checkbox v-model="column.visible" @input="save()"/>
                -->
              </v-list-item-icon>
              <v-list-item-title>{{favourite.name}}</v-list-item-title>
              <v-list-item-icon @click="deleteFavourite(favourite.id)">
                <v-icon>mdi-close-circle</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list>
        <v-divider class="my-2"/>
        <multi-level-select :menuData="favouritesPick" :second.sync="favourite" label="Add bookmark" :no-validation="true"
                                  outlined hint="Select a bookmark to add" persistent-hint @change="addFavourite()"/>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import sortableJS from 'sortablejs';
import reports from '@/mixins/reports'

export default {
  name: 'ToolsFavourites',
  mixins: [reports],
  data() {
    return {
      show: true,
      sortable: {options:{disabled:false}},
      myFavourites: [],
      favourite: null,
      favouritesPick: []
    }
  },
  computed: {
    myFavouriteNames() {
      if (!this.$store.getters.userSettings.favourites)
        this.$store.getters.userSettings.favourites = [];
      return this.$store.getters.userSettings.favourites;
    },
    permissions() {
      return this.$store.getters.company.permissions;
    }
  },
  created() {
    if (this.permissions.includes('production')) {
      this.favouritesPick.push({name:'Production',id:'production',
                                      menu:[{name:'Mashing',icon:'mdi-cogs',id:'ProductionMashing'},
                                            {name:'Create mash',icon:'mdi-cogs',plus:true,id:'ProductionMashingEditNew'},
                                            {name:'Distilling',icon:'mdi-cogs',id:'ProductionDistilling'},
                                            {name:'Create distillation',icon:'mdi-cogs',plus:true,id:'ProductionDistillingEditNew'},
                                            {name:'Blending',icon:'mdi-cogs',id:'ProductionBlending'},
                                            {name:'Create blend',icon:'mdi-cogs',plus:true,id:'ProductionBlendingEditNew'},
                                            {name:'Bottling',icon:'mdi-cogs',id:'ProductionBottling'},
                                            {name:'Create bottling',icon:'mdi-cogs',plus:true,id:'ProductionBottlingEditNew'},
                                            {name:'Assembly',icon:'mdi-cogs',id:'ProductionAssembly'},
                                            {name:'Create assembly',icon:'mdi-cogs',plus:true,id:'ProductionAssemblyEditNew'}]});
      this.favouritesPick.push({name:'Equipment',id:'equipment',
                                      menu:[{name:'Tanks',icon:'mdi-tools',id:'EquipmentTanks'},
                                            {name:'Fermenters',icon:'mdi-tools',id:'EquipmentFermenters'},
                                            {name:'Stills',icon:'mdi-tools',id:'EquipmentStills'},
                                            {name:'Other equipment',icon:'mdi-tools',id:'EquipmentOther'}]});
    }
    if (this.permissions.includes('inventory'))
      this.favouritesPick.push({name:'Inventory',id:'inventory',
                                      menu:[{name:'Products',icon:'mdi-tag',id:'InventoryProducts'},
                                            {name:'Batch product move list',icon:'mdi-tag',id:'InventoryProductsBatchMove'},
                                            {name:'Create batch product move',icon:'mdi-tag',plus:true,id:'InventoryProductsBatchMoveEditNew'},
                                            {name:'Reconcile product inv',icon:'mdi-tag',plus:true,id:'InventoryProductsReconcile'},
                                            {name:'Bulk containers',icon:'mdi-tag',id:'InventoryBulkContainers'},
                                            {name:'Casks',icon:'mdi-tag',id:'InventoryCasks'},
                                            {name:'Items & services',icon:'mdi-tag',id:'InventoryItems'},
                                            {name:'Reconcile item inventory',icon:'mdi-tag',plus:true,id:'InventoryItemsReconcile'},
                                            {name:'Bundles',icon:'mdi-tag',id:'InventoryBundles'}]});
    if (this.permissions.includes('selling'))
      this.favouritesPick.push({name:'Sales',id:'sales',
                                      menu:[{name:'Estimates',icon:'mdi-cart',id:'SalesEstimates'},
                                            {name:'Create estimate',icon:'mdi-cart',id:'SalesEstimatesEditNew'},
                                            {name:'Sales orders',icon:'mdi-cart',id:'SalesSalesOrders'},
                                            {name:'Create sales order',icon:'mdi-cart',plus:true,id:'SalesSalesOrdersEditNew'},
                                            {name:'Shipments',icon:'mdi-cart',id:'SalesShipments'},
                                            {name:'Create shipment',icon:'mdi-cart',plus:true,id:'SalesShipmentsEditNew'},
                                            {name:'Invoices',icon:'mdi-cart',id:'SalesInvoices'},
                                            {name:'Create invoice',icon:'mdi-cart',plus:true,id:'SalesInvoicesEditNew'},
                                            {name:'Customers',icon:'mdi-cart',id:'SalesCustomers'},
                                            {name:'Sales representitives',icon:'mdi-cart',id:'SalesReps'},
                                            {name:'Returns',icon:'mdi-cart',id:'SalesReturns'}]});
    if (this.permissions.includes('buying'))
      this.favouritesPick.push({name:'Purchasing',id:'purchasing',
                                      menu:[{name:'Purchase orders',icon:'mdi-credit-card-settings',id:'PurchasingPurchaseOrders'},
                                            {name:'Create purchase order',icon:'mdi-credit-card-settings',plus:true,id:'PurchasingPurchaseOrdersEditNew'},
                                            {name:'Inventory receipets',icon:'mdi-credit-card-settings',id:'PurchasingInventoryReceipts'},
                                            {name:'Create inv receipt',icon:'mdi-credit-card-settings',plus:true,id:'PurchasingInventoryReceiptsEditNew'},
                                            {name:'Suppliers',icon:'mdi-credit-card-settings',id:'PurchasingSuppliers'}]});
    if (this.permissions.includes('inventory'))
      this.favouritesPick.push({name:'Alcohol',id:'alcohol',
                                      menu:[{name:'Spirits',icon:'mdi-flask-empty',id:'Spirits'},
                                            {name:'Wine',icon:'mdi-flask-empty',id:'Wine'},
                                            {name:'Non-excise',icon:'mdi-flask-empty',id:'AlcoholNonExcises'}]});
    if (this.permissions.includes('forecasting') || this.permissions.includes('scheduling')) {
      const menu = [];
      if (this.permissions.includes('forecasting'))
        menu.push({name:'Forecasting',icon:'mdi-calendar-month',id:'PlanningForecasting'});
      if (this.permissions.includes('scheduling'))
        menu.push({name:'Scheduling',icon:'mdi-calendar-month',id:'PlanningScheduling'});
      this.favouritesPick.push({name:'Planning',id:'planning', menu});
    }
    if (this.permissions.includes('reports')) {
      const menu = [];
      for (const category of this.reports) {
        if (menu.length)
          menu.push({divider:true});
        for (const report of category.reports)
          menu.push({name:report.shortName??report.name, id:`ReportsView:${report.to}`, icon:'mdi-file-document-outline'});
      }
      this.favouritesPick.push({name:'Reports',id:'reports',menu});
    }
    this.myFavourites = this.myFavouriteNames.map(favourite => this.getFavourite(favourite));
  },
  mounted() {
    const _self = this;
    this.sortable = sortableJS.create(this.$refs.favourites.$el, {
      handle: '.handle',
      onEnd({newIndex, oldIndex}) {
        let selected = _self.myFavourites.splice(oldIndex, 1)[0];
        _self.myFavourites.splice(newIndex, 0, selected);
        selected = _self.myFavouriteNames.splice(oldIndex, 1)[0];
        _self.myFavouriteNames.splice(newIndex, 0, selected);
        _self.saveSettings();
      }
    })
  },
  beforeDestroy() {
    this.sortable.destroy();
  },
  methods: {
    getFavourite(favouriteId) {
      for (const menu of this.favouritesPick) {
        const favourite = menu.menu.find(favourite => favourite.id === favouriteId);
        if (favourite)
          return favourite;
      }
    },
    addFavourite() {
      if (this.myFavouriteNames.some(name => name === this.favourite))
        return;
      this.myFavouriteNames.push(this.favourite);
      this.myFavourites.push(this.getFavourite(this.favourite));
      this.saveSettings();
      this.$nextTick(() => this.favourite = null);
    },
    deleteFavourite(to) {
      const index = this.myFavouriteNames.findIndex(name => name === to);
      this.myFavouriteNames.splice(index, 1);
      this.myFavourites.splice(index, 1);
      this.saveSettings();
    },
    saveSettings() {
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    }
  }
}
</script>